/* Category previews use a consecutive prefix of verified Shopify IDs. */
(() => {
  const C=window.AutoDiazCatalog;if(!C || C.catalogScope)return;
  const TTL=60000,requests=new Map(),indexes=new Map();
  const id=value=>String(value ?? '').split('/').pop();
  const newest=(a,b)=>(Date.parse(b.created_at)||0)-(Date.parse(a.created_at)||0) || Number(id(b.id))-Number(id(a.id));
  const context=s=>[location.origin,s.root,s.revision,s.count,s.currency,s.country,s.locale].join('|');
  const productFields=`id handle title descriptionHtml productType vendor tags createdAt availableForSale
    priceRange { minVariantPrice { amount currencyCode } }
    featuredImage { url(transform:{maxWidth:480}) }
    options { name values }
    variants(first:3) { nodes { id title sku availableForSale selectedOptions { name value }
      price { amount currencyCode } image { url(transform:{maxWidth:480}) } } pageInfo { hasNextPage } }`;
  const query=`query AutoDiazExactProducts($ids:[ID!]!,$country:CountryCode,$language:LanguageCode)
    @inContext(country:$country,language:$language) { nodes(ids:$ids) { ... on Product { ${productFields} } } }`;
  const variantsQuery=`query AutoDiazExactVariants($id:ID!,$after:String,$country:CountryCode,$language:LanguageCode)
    @inContext(country:$country,language:$language) { product(id:$id) { id variants(first:250,after:$after) {
      nodes { id title sku availableForSale selectedOptions { name value } price { amount currencyCode } image { url(transform:{maxWidth:480}) } }
      pageInfo { hasNextPage endCursor } } } }`;
  function inlineProducts() {
    const out=new Map();
    for(const el of document.querySelectorAll('[data-ad-catalog-preview]'))try {
      const data=JSON.parse(el.textContent);
      if(data.version===3 && Array.isArray(data.products))for(const p of data.products)out.set(id(p.id),p);
    }catch{/* Inline data is optional. */}
    return out;
  }
  function validIndex(data,s) {
    return data?.complete===true && data.count===s.count && data.currency===s.currency &&
      Array.isArray(data.products) && data.products.length===s.count &&
      data.products.every(p=>p.id!=null && typeof p.title==='string' && Array.isArray(p.collections) && typeof p.created_at==='string' && Number.isFinite(Date.parse(p.created_at))) &&
      new Set(data.products.map(p=>id(p.id))).size===s.count;
  }
  async function index(s) {
    const key=context(s),cached=indexes.get(key);
    if(cached && cached.until>Date.now())return cached.promise;
    const entry={until:Date.now()+TTL};
    entry.promise=(async()=>{
      const storageKey='AutoDiazExactIndex|2|'+key,stored=s.cache?await C.cacheRead(storageKey):null;
      if(stored?.expiresAt>Date.now() && validIndex(stored.data,s))return stored.data;
      const records=new Map(),pages=Math.max(1,Math.ceil(s.count/250));let next=1;
      if(pages>100)throw new Error('Index exceeds Shopify pagination');
      await Promise.all(Array.from({length:Math.min(6,pages)},async()=>{
        while(next<=pages) {
          const page=next++,u=C.url('collections/all');
          u.searchParams.set('section_id','autodiaz-catalog-index');u.searchParams.set('page',String(page));u.searchParams.set('sort_by','created-descending');
          const doc=new DOMParser().parseFromString(await C.readText(u),'text/html'),el=doc.querySelector('[data-ad-catalog-index]');
          if(!el)throw new Error('Index section unavailable');
          const data=JSON.parse(el.content?.textContent || el.textContent);
          if(data.version!==1 || data.handle!=='all' || Number(data.page)!==page || Math.max(1,Number(data.pages))!==pages || Number(data.count)!==s.count || data.currency!==s.currency || !Array.isArray(data.products))throw new Error('Index changed during load');
          for(const p of data.products){const key=id(p.id);if(!key || records.has(key))throw new Error('Duplicate index product');records.set(key,p);}
        }
      }));
      const data={products:[...records.values()],count:s.count,currency:s.currency,complete:true};
      if(!validIndex(data,s))throw new Error('Incomplete index');
      if(s.cache)void C.cacheWrite(storageKey,{expiresAt:Date.now()+TTL,data}).catch(()=>{});
      return data;
    })().catch(e=>{indexes.delete(key);throw e;});indexes.set(key,entry);return entry.promise;
  }
  async function graphProducts(records,s) {
    const country=/^[A-Z]{2}$/.test(s.country || '')?s.country:null;
    const locale=String(s.locale || 'es').replace(/-/g,'_').toUpperCase(),language=/^[A-Z]{2}(?:_[A-Z]{2})?$/.test(locale)?locale:null;
    const response=JSON.parse(await C.readText(C.url('/api/2026-10/graphql.json'),null,{
      method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({query,variables:{ids:records.map(p=>'gid://shopify/Product/'+id(p.id)),country,language}})
    }));
    if(response.errors?.length || !Array.isArray(response.data?.nodes) || response.data.nodes.length!==records.length)throw new Error('Product query unavailable');
    return Promise.all(response.data.nodes.map(async(node,i)=>{
      const saved=records[i];
      if(!node || id(node.id)!==id(saved.id) || node.handle!==saved.handle || !Array.isArray(node.variants?.nodes))throw new Error('Missing exact product');
      if(node.priceRange.minVariantPrice.currencyCode!==s.currency || node.variants.nodes.some(v=>v.price.currencyCode!==s.currency))throw new Error('Market changed');
      let variants=node.variants.nodes.map(v=>({id:id(v.id),title:v.title,sku:v.sku,available:v.availableForSale,price:Number(v.price.amount),featured_image:v.image?{src:v.image.url}:null,
        ...Object.fromEntries((node.options || []).map((o,j)=>['option'+(j+1),v.selectedOptions.find(x=>x.name===o.name)?.value || null]))}));
      if(node.variants.pageInfo.hasNextPage) {
        const all=new Map();let after=null,rounds=0;
        do {
          if(++rounds>100)throw new Error('Variant pagination limit');
          const full=JSON.parse(await C.readText(C.url('/api/2026-10/graphql.json'),null,{
            method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
            body:JSON.stringify({query:variantsQuery,variables:{id:node.id,after,country,language}})
          }));
          const p=full.data?.product;
          if(full.errors?.length || id(p?.id)!==id(saved.id) || !Array.isArray(p?.variants?.nodes))throw new Error('Incomplete variants');
          for(const v of p.variants.nodes){
            if(v.price.currencyCode!==s.currency || all.has(id(v.id)))throw new Error('Variant context changed');
            all.set(id(v.id),{id:id(v.id),title:v.title,sku:v.sku,available:v.availableForSale,price:Number(v.price.amount),featured_image:v.image?{src:v.image.url}:null,
              ...Object.fromEntries((node.options || []).map((o,j)=>['option'+(j+1),v.selectedOptions.find(x=>x.name===o.name)?.value || null]))});
          }
          const cursor=p.variants.pageInfo?.endCursor;
          if(p.variants.pageInfo?.hasNextPage && (!cursor || cursor===after))throw new Error('Variant cursor repeated');
          after=p.variants.pageInfo?.hasNextPage?cursor:null;
        }while(after);
        if(variants.some(v=>!all.has(id(v.id)) || Math.abs(all.get(id(v.id)).price-v.price)>0.001 || all.get(id(v.id)).available!==v.available))throw new Error('Variant context changed');
        variants=[...all.values()];
      }
      if(!variants.length || variants.some(v=>!Number.isFinite(v.price) || v.price<0))throw new Error('Invalid product prices');
      return {...saved,title:node.title,description:C.plainProductText(node.descriptionHtml ?? node.description),product_type:node.productType,vendor:node.vendor,tags:node.tags,
        url:C.url('products/'+node.handle).pathname,image:node.featuredImage?.url || null,available:node.availableForSale,
        price:Number(node.priceRange.minVariantPrice.amount),price_varies:new Set(variants.map(v=>v.price)).size>1,created_at:node.createdAt,
        options:(node.options || []).map((o,j)=>({...o,position:j+1})),variants};
    }));
  }
  C.catalogScope=function(scope,options={}) {
    // A direct collection is read on its own, including every page and variant.
    // Batteries therefore require two collection pages, not the whole shop.
    if(scope.native && scope.leaf==='baterias') {
      // Supplier battery imports can belong to the electrical collection.
      // Preserve the union of both feeds, including these existing products.
      const found=new Map(),streams=new Map(),handles=[scope.handle,'electricidad-y-encendido'];
      const update=(handle,data)=>{
        streams.set(handle,data.products);found.clear();
        for(const products of streams.values())for(const p of products)if(C.matches(p,scope))found.set(id(p.id),p);
        try{options.onProgress?.({products:[...found.values()],currency:data.currency,complete:false,source:'liquid',previewStable:false});}catch{}
      };
      return Promise.all(handles.map(handle=>C.catalog(handle,{onProgress:data=>update(handle,data)}).then(data=>{update(handle,data);return data;})))
        .then(data=>{
          if(data.some(d=>!d.complete || d.currency!==data[0].currency))throw new Error('Battery collection changed');
          return {products:[...found.values()],currency:data[0].currency,complete:true,source:'liquid'};
        });
    }
    if(scope.native && (!scope.leaf || scope.leaf==='filtros'))return C.catalog(scope.handle,options);
    if(scope.family==='motores')return C.catalog('motores',options);
    // For the full shop / very large bodywork family, retain the verified full
    // feed and stream its results. Downloading an index as well would be wasteful.
    if(!scope.family || (scope.family==='carroceria-iluminacion' && !scope.leaf))return C.catalog('all',options);
    const s=C.readConfig();
    if(!s?.cache)return C.catalog('all',options);
    const key=context(s)+'|'+(scope.family || '')+'|'+(scope.leaf || '')+'|'+scope.handle;
    const listen=entry=>{
      const fn=options.onProgress;if(typeof fn==='function'){entry.listeners.add(fn);if(entry.latest)try{fn(entry.latest);}catch{}}
      return entry.promise.finally(()=>entry.listeners.delete(fn));
    };
    const old=requests.get(key);if(old?.until>Date.now())return listen(old);
    const entry={listeners:new Set(),latest:null,until:Date.now()+TTL};
    const progress=products=>{
      entry.latest={products,currency:s.currency,complete:false,source:'exact'};
      for(const fn of entry.listeners)try{fn(entry.latest);}catch{/* A UI listener cannot truncate a load. */}
    };
    entry.promise=(async()=>{
      const all=await index(s),selected=all.products.filter(p=>C.matches(p,scope)).sort(newest),inline=inlineProducts(),records=new Map();
      for(const p of selected){const seed=inline.get(id(p.id));if(seed)records.set(id(p.id),{...seed,created_at:p.created_at,fitment:p.fitment,collections:p.collections});}
      const publish=()=>{
        const prefix=[];for(const p of selected){const record=records.get(id(p.id));if(!record)break;prefix.push(record);}
        if(prefix.length)progress(prefix);
      };
      publish();
      const pending=selected.filter(p=>!records.has(id(p.id)));let next=0;
      await Promise.all(Array.from({length:Math.min(4,Math.ceil(pending.length/80))},async()=>{
        while(next<pending.length){const batch=pending.slice(next,next+=80),products=await graphProducts(batch,s);products.forEach(p=>records.set(id(p.id),p));publish();}
      }));
      if(records.size!==selected.length || selected.some(p=>!records.has(id(p.id))))throw new Error('Selection incomplete');
      return {products:selected.map(p=>records.get(id(p.id))),currency:s.currency,complete:true,source:'exact',scope};
    })().catch(()=>{return C.catalog('all',{onProgress:progressData=>progress(progressData.products.filter(p=>C.matches(p,scope)))});})
      .then(data=>{entry.latest=null;entry.until=Date.now()+TTL;return data;})
      .catch(error=>{requests.delete(key);throw error;});
    requests.set(key,entry);return listen(entry);
  };
})();
